/*
 | Routes
 | ---------
 | Use constants for router paths so we can
 | easily change it later
 */
export const PATH_HOME = '/'
export const PATH_ACCOUNT = '/account'
export const PATH_WORKSPACE = '/workspace'
export const PATH_ASSETS = '/assets'
export const PATH_EXPLORE = '/explore'
export const PATH_SUMMARY = '/summary'
export const PATH_DETAIL = '/detail'

export const GAUGES = [
  { key: 'workspace_utilization', name: 'Workspace Utilization', unit: '%', min: 0, max: 100 },
  { key: 'meeting_utilization', name: 'Meeting Utilization', unit: '%', min: 0, max: 100 },
  { key: 'mic', name: 'Sound', unit: 'dB', min: 0, max: 60 },
  { key: 'temp', name: 'Temperature', unit: '°C', min: 15, max: 28 },
  { key: 'lux', name: 'Light', unit: 'lux', min: 350, max: 550 },
  { key: 'humidity', name: 'Humidity', unit: '%', min: 10, max: 70 },
  { key: 'tvoc', name: 'TVOC', unit: 'ppb', min: 0, max: 450 },
  { key: 'co2', name: 'CO2', unit: 'ppm', min: 800, max: 1200 },
  { key: 'count', name: 'Count', unit: '', min: 0, max: 100 },
  { key: 'fixedAssets', name: 'Static Assets', unit: '%', min: 50, max: 100 },
  { key: 'mobileAssets', name: 'Mobile Assets', unit: '%', min: 50, max: 100 }
]
export const METRIC_NAMES = {
  temp: 'Temperature',
  humidity: 'Humidity',
  co2: 'eCO2',
  tvoc: 'TVOC',
  lux: 'Lux',
  mic: 'Sound',
  pm1: 'PM1.0',
  pm25: 'PM2.5',
  pm4: 'PM4.0',
  pm10: 'PM10.0',
  aqi: 'AQI',
  in: 'In(s)',
  out: 'Out(s)',
  workspaceUtilization: 'Workspace Utilization',
  meetingUtilization: 'Meeting Utilization',
  meetingOccupancy: 'Meeting Occupancy',

  //Terrasense metrics
  surfaceTemp: 'Surface Temperature',
  dewPoint: 'Dew Point',
  surfaceHumidity: 'Surface Humidity',
  atmosPressure: 'Atmospheric Pressure',
  windSpeed: 'Wind Speed',
  windDirection: 'Wind Direction',
  rainfall: 'Rainfall',
  solarRadiation: 'Solar Radiation',
  illumination: 'Illumination',

  //SoilSense
  soilTemp: 'Soil Temperature Top',
  soilTemperatureMid: 'Soil Temperature Mid',
  soilTemperatureBot: 'Soil Temperature Bottom',

  soilMoisture: 'Soil Moisture Top',
  soilMoistureMid: 'Soil Moisture Mid',
  soilMoistureBot: 'Soil Moisture Bottom',

  ph: 'pH Top',
  phMid: 'pH Mid',
  phBot: 'pH Bottom',
  conductivity: 'Bulk EC Top',
  conductivityMid: 'Bulk EC Mid',
  conductivityBot: 'Bulk EC Bottom',

  poreWaterEc: 'Pore Water EC Top',
  poreWaterEcMid: 'Pore Water EC Mid',
  poreWaterEcBot: 'Pore Water EC Bottom',

  nitrogen: 'Nitrogen Top',
  nitrogenMid: 'Nitrogen Mid',
  nitrogenBot: 'Nitrogen Bottom',
  phosphorus: 'Phosphorous Top',
  phosphorusMid: 'Phosphorous Mid',
  phosphorusBot: 'Phosphorous Bottom',
  potassium: 'Potassium Top',
  potassiumMid: 'Potassium Mid',
  potassiumBot: 'Potassium Bottom',
  salinity: 'Salinity Top',
  salinityMid: 'Salinity Mid',
  salinityBot: 'Salinity Bottom',
  tds: 'TDS Top',
  tdsMid: 'TDS Mid',
  tdsBot: 'TDS Bottom',
  waterLevelLitres: 'Water Level (L)',
  waterLevelCm: 'Water Level (cm)',

}
export const STATUS = {
  OK: 1,
  WARNING: 2,
  CONSIDERABLE: 3,
  DANGEROUS: 4,
  ERROR: 5
}

export const HEALTH_STATUS = {
  OK: 'OK',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL'
}

export const RANGE = {
  MONTH: 30,
  WEEK: 7,
  DAY: 1,
  HOUR: 0
}

export const SENSOR_TYPE = {
  PEBBLE: 1,
  DOC: 2,
  ABACUS: 3,
  POINTGRAB: 4,
  AIRLAB: 5,
  TERRASENSE: 9,
  BUTTON: 7
}

export const PATH = {
  HOME: '/',
  ACCOUNT: '/account',
  LOGIN: '/login',

  EVENTS: '/events',

  // Sensors
  SENSORS: '/devices',
  SENSORS_LIST: '/devices/management',
  SENSORS_DETAIL: '/devices/management/%s',
  DEVICES_EVENTS: '/devices/events',

  // Reporting
  REPORTING_UTILIZATION_SPACES: '/reporting/utilization/spaces',
  REPORTING_UTILIZATION_ROOMS: '/reporting/utilization/rooms',
  REPORTING_UTILIZATION_TRAFFIC: '/reporting/utilization/traffic',
  REPORTING_HUMAN_EXPERIENCE_COMFORT: '/reporting/human-experience/comfort',
  REPORTING_AIR_QUALITY_HEALTH: '/reporting/air-quality/health',
  REPORTING_AIR_QUALITY_INDEX: '/reporting/aqi',
  REPORTING_HUMAN_EXPERIENCE_PRODUCTIVITY: '/reporting/human-experience/productivity',
  REPORTING_AREA_BREAKDOWN: '/reporting/area-breakdown',
  REPORTING_ANALYTICS: '/reporting/analytics',
  REPORTING_REPORT: '/reporting/report',
  REPORTING_RUNOFF: '/reporting/runoff',
  REPORTING_SUPPLY_CHAIN_REPORT: '/reporting/supply-chain-report',
  REPORTING_STD_BANK_UTILIZATION: '/reporting/std-bank-utilization', // CUSTOM - STD BANK DASHBOARD
  REPORTING_TECHDATA_OCC: '/reporting/techdata-occupancy', // CUSTOM - Tech Data Demo
  REPORTING_TECHDATA_AIR: '/reporting/techdata-air', // CUSTOM - Tech Data Demo
  REPORTING_AMSTERDAM: '/reporting/amsterdam-demo', // CUSTOM - Amsterdam demo
  REPORTING_GYM: '/reporting/gym', // CUSTOM - Amsterdam demo
  REPORTING_DIDATA: '/reporting/didata', // CUSTOM - Amsterdam demo
  REPORTING_SILO: '/reporting/silo', // CUSTOM - Amsterdam demo

  // Account
  ACCOUNT_PROFILE: '/account/profile',
  ACCOUNT_NOTIFICATIONS: '/account/notifications',
  ACCOUNT_INTEGRATIONS: '/account/integrations',
  ACCOUNT_MEMBERS: '/account/members',
  ACCOUNT_COMPANIES: '/account/companies',
  ACCOUNT_DATA_REFACTORING: '/account/dataRefactoring',

  // Workspace
  WORKSPACE_BUILDING: '/workspace/properties',
  WORKSPACE_FLOORS: '/workspace/floors',
  WORKSPACE_AREAS: '/workspace/areas',
  WORKSPACE_VIEWER: '/workspace/viewer',

  // Sensy
  SENSY_SURVEYS: '/sensy/surveys',
  SENSY_SURVEYS_DETAIL: '/sensy/surveys/%s',
  COVID_STATUS: '/sensy/covid',
  SENSY_NOTIFICATIONS: '/sensy/notifications',
  SENSY_SUGGESTIONS: '/sensy/suggestions',
  SENSY_SUGGESTION_DETAIL: '/sensy/suggestions/%s',
  SENSY_FIXIT: '/sensy/fixit',
  SENSY_FIXIT_DETAIL: '/sensy/fixit/%s',

  EDITOR: '/editor/%s',

  // Workflow automation
  FLOW_EDITOR: '/flow-editor',
  FLOW_EDITOR_ADD: '/flow-editor/new',
  FLOW_EDITOR_DETAIL: '/flow-editor/%s',

  //---------------------------------------------------------------------------
  //Terrasense
  //Home
  TERRASENSE_HOME: '/ergoagri',
  TERRASENSE_PROPERTIES: '/ergoagri/properties',
  TERRASENSE_BLOCKS: '/ergoagri/blocks',
  TERRASENSE_AREAS: '/ergoagri/areas',
  //Reporting
  REPORTING_ANALYTICS_TERRASENSE: '/reporting/analytics/ergoagri',
  //Workspace
  PROPERTY_VIEWER: '/workspace/ergoagri/viewer',
}

/**
 * Permission constant map.
 *
 * @type {object}
 */
export const PERMISSION = {
  ADMIN: 'admin',
  ERGOSENSE: 'ergosense'
}

/**
 * Survey types
 *
 * @type {object}
 */
export const SURVEY_TYPE = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  SCALE: 'SCALE'
}
